import React from 'react';
import { FiPhone, FiArrowRight, FiStar, FiShield } from 'react-icons/fi';
import './Hero.css';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const heroStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/shopImages-1.jpeg)`
  };

  return (
    <section id="hero" className="hero" style={heroStyle}>
      <div className="hero__overlay"></div>
      <div className="hero__content">
        <div className="hero__badge">
          <FiShield className="hero__badge-icon" />
          <span>Trusted Since 2015 • 5.0 Rating • 100% Recommend</span>
        </div>

        <h1 className="hero__title">
          Expert Auto<br />
          <span className="hero__title-accent">Collision Repair</span>
        </h1>

        <p className="hero__subtitle">
          Professional restoration with precision craftsmanship.<br />
          Your vehicle deserves the best care in Spring, TX.
        </p>

        <div className="hero__features">
          <div className="hero__feature">
            <FiShield />
            <span>Lifetime Warranty</span>
          </div>
          <div className="hero__feature">
            <FiStar />
            <span>9 Years Experience</span>
          </div>
          <div className="hero__feature">
            <FiPhone />
            <span>Free Estimates</span>
          </div>
        </div>

        <div className="hero__cta">
          <button className="btn btn--primary btn--large" onClick={scrollToContact}>
            <span>Get Your Free Estimate</span>
            <FiArrowRight />
          </button>
          <a href="tel:+18326156065" className="btn btn--secondary btn--large">
            <FiPhone />
            <span>(832) 615-6065</span>
          </a>
        </div>

        <p className="hero__note">
          Call us today or request an estimate online • Open Mon-Fri 8AM-5:30PM
        </p>
      </div>
    </section>
  );
};

export default Hero;
